"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataTypes = exports.mergeTriggerSymbols = exports.parentChildDelimiter = void 0;
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var parentChildDelimiter = '.';
exports.parentChildDelimiter = parentChildDelimiter;
var mergeTriggerSymbols = ['@', '#', '$'];
exports.mergeTriggerSymbols = mergeTriggerSymbols;
var entityTypes = {
  personDataType: 'PERSON_DATA_TYPE',
  globalDataType: 'GLOBAL_DATA_TYPE',
  libraryBlockType: 'LIBRARY_BLOCK_TYPE',
  promotionType: 'PROMOTION_TYPE',
  promotionFieldType: 'PROMOTION_FIELD_TYPE',
  lookupType: 'LOOKUP_TYPE',
  lookupFieldType: 'LOOKUP_FIELD_TYPE'
};
var primitiveTypes = {
  stringType: 'STRING_TYPE',
  numberType: 'NUMBER_TYPE',
  integerType: 'INTEGER_TYPE',
  booleanType: 'BOOLEAN_TYPE'
};
var dataTypes = _objectSpread({}, entityTypes, primitiveTypes);
exports.dataTypes = dataTypes;